const API_URL = process.env.REACT_APP_API_URL || '/api';

async function getAuthHeaders() {
    try {
        // Get the current user's session from localStorage
        const idToken = localStorage.getItem('idToken');
        const tokenExpiry = localStorage.getItem('tokenExpiry');
        
        if (!idToken) {
            throw new Error('No authentication token found');
        }

        // Check if token is expired
        if (tokenExpiry && Date.now() >= parseInt(tokenExpiry)) {
            // Clear tokens and redirect to login
            localStorage.removeItem('idToken');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('tokenExpiry');
            
            // Get Cognito domain for login
            const domainPrefix = process.env.REACT_APP_USER_POOL_ID.replace('_', '');
            const domain = `https://${domainPrefix}.auth.us-east-2.amazoncognito.com`;
            
            // Construct login URL
            const loginUrl = `${domain}/login?` +
                `client_id=${process.env.REACT_APP_USER_POOL_CLIENT_ID}&` +
                `response_type=code&` +
                `redirect_uri=${encodeURIComponent(process.env.REACT_APP_REDIRECT_SIGNIN)}`;
            
            window.location.href = loginUrl;
            throw new Error('Session expired. Redirecting to login...');
        }

        return {
            'Authorization': `Bearer ${idToken}`,
            'Content-Type': 'application/json'
        };
    } catch (error) {
        console.error('Error getting auth token:', error);
        throw new Error(error.message || 'Not authenticated');
    }
}

export async function apiGet(endpoint) {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_URL}${endpoint}`, {
        method: 'GET',
        headers
    });
    
    if (!response.ok) {
        const error = new Error(`API error: ${response.status}`);
        error.status = response.status;
        error.response = response;
        throw error;
    }
    
    return response.json();
}

export async function apiPost(endpoint, data) {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_URL}${endpoint}`, {
        method: 'POST',
        headers,
        body: JSON.stringify(data)
    });
    
    if (!response.ok) {
        const error = new Error(`API error: ${response.status}`);
        error.status = response.status;
        error.response = response;
        throw error;
    }
    
    return response.json();
}

export async function apiPostFormData(endpoint, formData) {
    const headers = await getAuthHeaders();
    // Remove Content-Type as FormData will set it with the correct boundary
    delete headers['Content-Type'];
    
    const response = await fetch(`${API_URL}${endpoint}`, {
        method: 'POST',
        headers,
        body: formData
    });
    
    if (!response.ok) {
        const error = new Error(`API error: ${response.status}`);
        error.status = response.status;
        error.response = response;
        throw error;
    }
    
    return response.json();
}

export async function apiPut(endpoint, data) {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_URL}${endpoint}`, {
        method: 'PUT',
        headers,
        body: JSON.stringify(data)
    });
    
    if (!response.ok) {
        const error = new Error(`API error: ${response.status}`);
        error.status = response.status;
        error.response = response;
        throw error;
    }
    
    return response.json();
}

export async function apiDelete(endpoint) {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_URL}${endpoint}`, {
        method: 'DELETE',
        headers
    });
    
    if (!response.ok) {
        const error = new Error(`API error: ${response.status}`);
        error.status = response.status;
        error.response = response;
        throw error;
    }
    
    return response.json();
}

export { getAuthHeaders };
